import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.lootbox.boxes,
    (boxes) => {
        return {
            boxes
        }
    }
)